module.exports = __webpack_public_path__ + "static/media/close_icon_2_white.4a69ad52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_icon_2_white.svg
// module id = 965
// module chunks = 0